import { Trash2 } from 'blaze-ui/icons'
import Styles from './ShapeToDeleteOverlay.module.scss'

import { ShapeToDeleteOverlayProps } from './Types'
import { ShapeOverlay } from '../ShapeOverlay/ShapeOverlay'

const ShapeToDeleteOverlay = ({ shape }: ShapeToDeleteOverlayProps) => {
  return (
    <ShapeOverlay shape={shape} className={Styles.shapeToDeleteOverlay}>
      <div className={Styles.button}>
        <Trash2 size={30} color="var(--light-100)" />
      </div>
    </ShapeOverlay>
  )
}

export { ShapeToDeleteOverlay }
